function Header() {
  return (
    <div className="container my-4">
	<div className="jumbotron">
  <h1 className="display-4">Hello, world!</h1>
  <p className="lead">This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.</p>
  <hr className="my-4"/>
  <p>You Can nevigate page without reloading the browser it is the power of React js......!</p>
  <span className="btn btn-primary btn-lg" role="button">Learn more</span>
</div>
    </div>
  );
}

export default Header;
